import { render, staticRenderFns } from "./GItemImageForm.vue?vue&type=template&id=2866db64&scoped=true&"
import script from "./GItemImageForm.vue?vue&type=script&lang=ts&"
export * from "./GItemImageForm.vue?vue&type=script&lang=ts&"
import style0 from "./GItemImageForm.vue?vue&type=style&index=0&id=2866db64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2866db64",
  null
  
)

export default component.exports